<template>
  <div class="main_detect_home">
    <div class="main_detect_header">
        <h1 style="height:60px;font-size:20px;background:#0072ff;text-align:center;color:white;line-height:60px;">
            {{ group.name }}
        </h1>
    </div>
    <a-spin tip="加载中..." style="width:100%;text-align:center;margin-top:20px;" :spinning="loading">
    </a-spin>
    <div class="main_detect_content" :style="{'display':loading?'none':'block'}">
        <ul :class="{ 'grid-layout-9': group_object && group_object.group && group_object.group.report_index === 9999 }" style="display:grid;margin:0;padding:0" v-if="!loading">
            <li v-for="(group_item, index) in group.group_items" :key="index" style="margin-top:20px;">
                <span style="text-align:left;width:100%;height:40px;display:block;font-size:16px;margin-top:20px;">
                    {{ group_item.name }}
                </span>
                <FileUpload 
                    style="margin-top:10px;"
                    v-if="group_item.identifier && fileUploadArguments[String(group_item.identifier)] && group_item.items && group_item.items.length > 0 && group_item.items[0].mode=='IMAGES' && group_item.choice_mode=='DEFAULT'" 
                    v-bind:argument="fileUploadArguments[String(group_item.identifier)]" 
                >
                </FileUpload>
                <a-radio-group 
                style="margin-top:10px;"
                name="radioGroup" 
                v-if="group_item.items && group_item.items.length > 0 && group_item.items[0].mode=='BOOLEAN' && group_item.choice_mode=='SINGLE'" 
                v-model="group_item.value" 
                @change="singleRadioChange(group_item.identifier, $event)">
                    <a-radio :value="item.identifier" v-for="(item, idx) in group_item.items" :key="idx" style="margin-left:5px;font-size:16px;">
                        {{ item.name }} 
                    </a-radio>
                </a-radio-group>
                <el-checkbox-group 
                v-model="group_item.value" 
                el-checkbox="mini"
                style="margin:0;padding:0;margin-top:10px;font-size:16px;" 
                v-if="group_item.value && group_item.items && group_item.items.length > 0 && group_item.items[0].mode=='BOOLEAN' && group_item.choice_mode=='MULTIPLE'">
                    <li style="float:left;margin:0;padding:0;margin-right:10px;"  v-for="(item, idx) in group_item.items" :key="idx">
                        <el-checkbox style="font-size:16px;" :label="item.identifier" border :key="item.identifier" @change="multipleRadioChange(group_item.identifier, item.identifier, $event)">{{ item.name }}</el-checkbox>
                    </li>
                </el-checkbox-group>
                <a-textarea 
                :autoSize=false
                v-model="textArgument[String(group_item.identifier)]" 
                style="height:100px;margin-top:10px;" 
                :placeholder="placeholderArgument[String(group_item.identifier)]"
                v-if="group_item.items && group_item.items.length > 0 && group_item.items[0].mode=='TEXT' && group_item.items[0].text_mode=='TextArea' && group_item.choice_mode=='DEFAULT'">
                    
                </a-textarea>
                <a-input 
                @change="textAreaChange(group_item.identifier, $event)" 
                v-model="textArgument[String(group_item.identifier)]" 
                style="height:100px;margin-top:10px;" 
                :placeholder="placeholderArgument[String(group_item.identifier)]"
                v-if="group_item.items && group_item.items.length > 0 && group_item.items[0].mode=='TEXT' && group_item.items[0].text_mode=='Input' && group_item.choice_mode=='DEFAULT'">
                    
                </a-input>
                <span style="height:100px;margin-top:10px;" v-if="group_item.items && group_item.items.length > 0 && group_item.items[0].mode=='TEXT' && group_item.items[0].text_mode=='TextView' && group_item.choice_mode=='DEFAULT'">
                    {{ group_item.items[0].placeholder }}
                </span>
            </li>
            
        </ul>
        <ul style="display:grid;margin:0;padding:0">
            <li style="margin-top:30px;">
                <span style="text-align:left;width:100%;height:40px;display:block;font-size:16px;">
                    检测结果
                </span> 
                <a-textarea 
                :autoSize=false
                v-model="group_object.test_result" 
                style="height:100px;" 
                placeholder="请输入检测结果">
                    
                </a-textarea>
            </li>
            <li style="width:100%;height:70px;margin-top:40px;">
                <a-button type="primary" @click="update_detect_group_object" :loading="commit_loading" style="border-radius:5px;background:#1890ff;display:block;width:100%;height:50px;line-height:50px;margin-top:20px;color:white;font-size:20px;text-align:center;">
                    保存
                </a-button>                     
            </li>
        </ul>
    </div>
    <div style="width:100%;height:70px;margin-top:50px;">
        <span style="line-height:70px;text-align:center;display:block;margin:0 auto;">
            {{ company.copyright_no }} 版权所有
        </span>
        <a style="text-align: center;width:100%;line-height: 20px;height:20px;display:block;" href="https://beian.miit.gov.cn" target="_blank">{{ company.record_no }}</a>
    </div>
  </div>
</template>

<script>
import FileUpload from "../upload/FileUpload.vue"

import order_model from '../../model/order'
import group_model from '../../model/detect_group'
import request from '../../api/request'
import company_model from '../../model/company'
import watermark from 'watermark-dom'

export default {
    name: 'Detect',
    data: function() {
        return {
            order_id: "",
            group_id: "", 
            order: order_model,
            group: group_model,
            group_object: {},
            menu: {},
            fileUploadArguments: {
                
            },
            textArgument: {

            },
            placeholderArgument: {

            },
            loading: false,
            commit_loading: false, 
            company: company_model,
        }
    },
    methods: {
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        header(index, group_item) {
            if (group_item.value && group_item.value.length > 0) {
                return String(index+1) + ". " + group_item.name + "  [已检测]"
            }
            return String(index+1) + ". " + group_item.name
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            
            this.fetch_company()
            this.order_id = this.$route.query.order_id
            this.group_id = this.$route.query.group_id
            this.fetchOrder()
        },
        textAreaChange(group_item_id, e) {
            this.textArgument[group_item_id] = e.target.value
        },
        multipleRadioChange(group_item_id, item_identifier, value) {
            if (this.menu && this.menu.groups) {
                for (var group of this.menu.groups) {
                    if (group.group_items) {
                        for (var group_item of group.group_items) {
                            if (group_item.identifier == group_item_id && group_item.items && group_item.items.length > 0) {
                                if (!group_item.value) {
                                    group_item.value = []
                                }
                                var index = group_item.value.indexOf(item_identifier);
                                if (value == true) {
                                    console.log(value)
                                    if (index < 0) {
                                        group_item.value.push(item_identifier)
                                    }
                                }
                                else {
                                    if (index >= 0) {
                                        group_item.value.splice(index, 1)
                                    }
                                }
                                this.$forceUpdate()
                                return
                            }
                        }
                    }
                }
            }
        },
        singleRadioChange(group_item_id, e) {
            var item_identifier = e.target.value
            if (this.menu && this.menu.groups) {
                for (var group of this.menu.groups) {
                    if (group.group_items) {
                        for (var group_item of group.group_items) {
                            if (group_item.identifier == group_item_id && group_item.items && group_item.items.length > 0) {
                                group_item.value = item_identifier
                                this.$forceUpdate()
                            }
                        }
                    }
                }
            }
        },
        fetchMenu(menu_identifier) { 
            var menu_detail_resp = request.order.menu_detail(menu_identifier)
            menu_detail_resp.then((response) => { 
                var failed_message = "获取套餐信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.menu = response.data.data
                        this.loading = false
                        this.fetchGroupObject()
                    }
                    else {
                        this.$message.error(failed_message)
                    }
                }
                else {
                    this.loading = false
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
        },
        fetchGroupObject() { 
            var group_object_resp = request.order.group_object_detail(this.order_id, this.group_id)
            group_object_resp.then((response) => { 
                var failed_message = "获取数据信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.group_object = response.data.data
                        this.loading = false
                        var index = 0
                        if (this.menu) {
                            var group_dict = {}
                            for (index;index<this.menu.groups.length;index++) {
                                group_dict = this.menu.groups[index]
                                if (group_dict && group_dict.identifier == this.group_id) {
                                    this.group = group_dict
                                }
                            }
                        }
                        
                        if (this.group) {
                            this.fileUploadArguments = {}
                            var idx = 0
                            if (this.group.group_items) {
                                for (var group_item of this.group.group_items) {
                                    if (group_item.items) {
                                        for (var item of group_item.items) {
                                            if (
                                                item.mode == 'IMAGES' 
                                                ) {
                                                    var coversArgument = {
                                                        id: idx,
                                                        click_name: "点击上传",
                                                        key: "image_"+String(idx),
                                                        accept: ".png, .jpg, .jpeg, .gif, .bmp",
                                                        max_file_count: this.group_object && this.group_object.group && this.group_object.group.report_index === 9999 ? 1 : 99999999,
                                                        unlimit_count: this.group_object && this.group_object.group && this.group_object.group.report_index === 9999 ? false : true,
                                                        fileList: [],
                                                    }
                                                    if (this.group_object.detect_detectitemobject_group_object) {
                                                        for (var i_detect_item_object of this.group_object.detect_detectitemobject_group_object) {
                                                            if (
                                                                i_detect_item_object.detect_item.identifier == item.identifier &&
                                                                i_detect_item_object.detect_group_item.identifier == group_item.identifier
                                                                ) {
                                                                if (i_detect_item_object.images) {
                                                                    for (var image_dict of i_detect_item_object.images) {
                                                                        var item_image_dict = {
                                                                            uid: image_dict.identifier,
                                                                            name: 'image.png',
                                                                            status: 'done',
                                                                            url:image_dict.image_url,
                                                                        }
                                                                        console.log(coversArgument)
                                                                        coversArgument.fileList.push(item_image_dict)
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    
                                                    this.fileUploadArguments[String(group_item.identifier)] = coversArgument
                                                    // console.log(this.fileUploadArguments)
                                                    idx ++
                                                }
                                                else if (item.mode=='BOOLEAN') {
                                                    if (group_item.choice_mode=='SINGLE') {
                                                        if (!group_item.value) {
                                                            group_item.value = ''
                                                        }
                                                    }
                                                    else if (group_item.choice_mode=='MULTIPLE') {
                                                        if (!group_item.value) {
                                                            group_item.value = []
                                                        }
                                                    }
                                                    if (this.group_object.detect_detectitemobject_group_object) {
                                                        for (var b_detect_item_object of this.group_object.detect_detectitemobject_group_object) {
                                                            if (
                                                                b_detect_item_object.detect_item.identifier == item.identifier && 
                                                                b_detect_item_object.detect_group_item.identifier == group_item.identifier &&
                                                                b_detect_item_object.checked == true
                                                                ) {
                                                                if (group_item.choice_mode=='SINGLE') {
                                                                    group_item.value = item.identifier
                                                                }
                                                                else if (group_item.choice_mode=='MULTIPLE') {
                                                                    group_item.value.push(item.identifier)
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else if (item.mode=='TEXT' && group_item.choice_mode=='DEFAULT') {
                                                    if (this.group_object.detect_detectitemobject_group_object) {
                                                        for (var t_detect_item_object of this.group_object.detect_detectitemobject_group_object) {
                                                            // console.log(group_item)
                                                            if (
                                                                t_detect_item_object.detect_group_item.identifier == group_item.identifier &&
                                                                t_detect_item_object.detect_item.identifier == item.identifier
                                                                ) {
                                                                    this.textArgument[String(group_item.identifier)] = t_detect_item_object.text
                                                            }

                                                        }
                                                    }
                                                    if (!this.textArgument[String(group_item.identifier)]) {
                                                        this.textArgument[String(group_item.identifier)] = ""
                                                        this.placeholderArgument[String(group_item.identifier)] = item.placeholder
                                                    }
                                                }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        this.$message.error(failed_message)
                    }
                }
                else {
                    this.loading = false
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
        },
        fetchOrder() {
            this.loading = true
            var order_detail_resp = request.order.detail(this.order_id)
            order_detail_resp.then((response) => {
                this.loading = false
        // handle success
                var failed_message = "获取订单信息失败"
                if (response && response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.order = response.data.data
                        var menu_id = this.order.menu_id
                        this.fetchMenu(menu_id)
                        
                    }
                    this.$forceUpdate()
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
            
        },
        update_detect_group_object() {
            this.commit_loading = true
            console.log("update_detect_group_object", this.order, this.group_object.identifier, this.group, this.menu, this.textArgument, this.group_object.test_result)
            
            // 安卓环境下的错误处理优化
            const isAndroid = /(Android)/i.test(window.navigator.userAgent);
            
            var update_detect_object_resp = request.detect_object.update_detect_group_object(this.order, this.group_object, this.group, this.menu.identifier, this.fileUploadArguments, this.textArgument, this.group_object.test_result)
            update_detect_object_resp.then((response) => {
                this.commit_loading = false
                var failed_message = "保存检测组信息失败"
                var success_message = "保存检测组信息成功"
                if (
                    response && 
                    response.status == 200 && 
                    response.data.code == 0
                    ) {
                    if (response.data && response.data.message) {
                        success_message = response.data.message
                    }
                    this.$router.go(-1)
                    this.$message.success(success_message)
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    // 安卓环境下提供更详细的错误信息
                    if (isAndroid && response.status === 400) {
                        failed_message += "，请检查网络连接或重试"
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.commit_loading = false
                let errorMessage = "请求失败，请联系管理员";
                
                // 安卓环境下的错误处理优化
                if (isAndroid) {
                    if (error.code === 'NETWORK_ERROR' || error.message.includes('Network Error')) {
                        errorMessage = "网络连接失败，请检查网络后重试";
                    } else if (error.code === 'TIMEOUT' || error.message.includes('timeout')) {
                        errorMessage = "请求超时，请重试";
                    } else if (error.response && error.response.status === 400) {
                        errorMessage = "请求参数错误，请检查上传的文件格式和大小";
                    }
                }
                
                if (error) {
                    this.$error({
                        title: errorMessage,
                        content: String(error),
                    });
                }
            })
            
        }
    },
    created() {
        this.load()
    },
    components: {
        FileUpload
    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

.main_detect_home {
    margin: 0;
    padding: 0;
}

.main_detect_content {
    margin: 0;
    padding: 0;
    margin-left: 5vw;
    margin-right: 5vw;
    margin-bottom: 0;
    margin-top: 30px;
}

.main_content > ul {
    margin: 0;
    padding: 0;
}

.edit_footer {
    background: #99999999;
    display: block;
    width: 100%;
    height: 50px;
    margin: 0;
    padding: 0;
}

.edit_footer span {
    padding: 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    line-height: 50px;
}

/* 9宫格布局样式 - 增强兼容性 */
.grid-layout-9 {
    display: -webkit-grid;
    display: -ms-grid;
    display: grid;
    -webkit-grid-template-columns: repeat(3, 1fr);
    -ms-grid-columns: 1fr 1fr 1fr;
    grid-template-columns: repeat(3, 1fr);
    -webkit-grid-gap: 15px;
    -ms-grid-gap: 15px;
    grid-gap: 15px;
    gap: 15px;
    margin: 0;
    padding: 0;
    width: 100%;
    box-sizing: border-box;
}

.grid-layout-9 > li {
    border-radius: 8px;
    padding: 15px;
    margin: 0 !important;
    transition: all 0.3s ease;
    box-sizing: border-box;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.grid-layout-9 > li:hover {
    transform: translateY(-2px);
}

.grid-layout-9 > li > span {
    font-weight: 600;
    color: #495057;
    margin-bottom: 10px;
    display: block;
    text-align: center;
    font-size: 14px;
    line-height: 1.4;
}

/* 响应式设计 - 针对不同屏幕尺寸优化 */
@media screen and (max-width: 1024px) {
    .grid-layout-9 {
        -webkit-grid-template-columns: repeat(3, 1fr);
        -ms-grid-columns: 1fr 1fr 1fr;
        grid-template-columns: repeat(3, 1fr);
        -webkit-grid-gap: 12px;
        -ms-grid-gap: 12px;
        grid-gap: 12px;
        gap: 12px;
    }
}

@media screen and (max-width: 768px) {
    .grid-layout-9 {
        -webkit-grid-template-columns: repeat(3, 1fr);
        -ms-grid-columns: 1fr 1fr 1fr;
        grid-template-columns: repeat(3, 1fr);
        -webkit-grid-gap: 10px;
        -ms-grid-gap: 10px;
        grid-gap: 10px;
        gap: 10px;
    }
    
    .grid-layout-9 > li {
        padding: 12px;
        min-height: 100px;
    }
    
    .grid-layout-9 > li > span {
        font-size: 13px;
    }
}

@media screen and (max-width: 480px) {
    .grid-layout-9 {
        -webkit-grid-template-columns: repeat(3, 1fr);
        -ms-grid-columns: 1fr 1fr 1fr;
        grid-template-columns: repeat(3, 1fr);
        -webkit-grid-gap: 8px;
        -ms-grid-gap: 8px;
        grid-gap: 8px;
        gap: 8px;
    }
    
    .grid-layout-9 > li {
        padding: 10px;
        min-height: 90px;
    }
    
    .grid-layout-9 > li > span {
        font-size: 12px;
        margin-bottom: 8px;
    }
}

/* 华为手机特殊优化 */
@media screen and (max-width: 414px) and (-webkit-min-device-pixel-ratio: 2) {
    .grid-layout-9 {
        display: -webkit-grid !important;
        display: grid !important;
        -webkit-grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
        -webkit-grid-gap: 8px !important;
        grid-gap: 8px !important;
        gap: 8px !important;
    }
}

/* 强制Grid布局生效 */
@supports (display: grid) {
    .grid-layout-9 {
        display: grid !important;
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
}

/* Fallback for older browsers */
@supports not (display: grid) {
    .grid-layout-9 {
        display: -webkit-flex;
        display: flex;
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
        -webkit-justify-content: space-between;
        justify-content: space-between;
    }
    
    .grid-layout-9 > li {
        width: calc(33.333% - 10px);
        margin-bottom: 15px;
    }
}

</style>
